export default function ArtworkMedia({ piece, alt, paused = false, mediaRef }) {
  if (piece.video) {
    return (
      <video
        ref={mediaRef}
        className="artwork"
        poster={piece.image || undefined}
        autoPlay={!paused}
        muted
        loop
        playsInline
        onCanPlay={(e) => { if (!paused) e.currentTarget.play().catch(() => {}); }}
        aria-label={alt}
      >
        <source src={piece.video} type="video/mp4" />
        {piece.videoWebm && <source src={piece.videoWebm} type="video/webm" />}
      </video>
    );
  }
  if (piece.image) {
    return <img className="artwork" src={piece.image} alt={alt} />;
  }
  return null;
}
